import React, { useEffect, useState, useRef } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import "./AddWebProduct.scss";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { webProductListApi } from "services/product";
import CustomButton, { SearchBar } from "components/form";
import { AddModel } from "./AddModel";
import Placeholder from "components/placeholder/Placeholder";
import { ProductPlaceholderImg } from "assets/images";
import { FaStar } from "react-icons/fa";
import useFullPageLoader from "common/UseFullPageLoader";

const AddWebProduct = () => {
  const submitButtonRef = useRef(null);
  const [productList, setProductList] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [errors, setErrors] = useState({});
  const [addModal, setAddModal] = useState(false);
  const [showList, setShowList] = useState(false);
  const [selectAll, setSelectAll] = useState(false); // New state for Select All
  const [loader, onShow, onHide] = useFullPageLoader();
  console.log("productList", productList);
  // Fetch product list
  const scrapeProductListHandler = async (url = search) => {
    try {
      onShow();
      const res = await webProductListApi({ url });
      if (res?.data?.status === 200) {
        const filteredProducts = res?.data?.data?.products
          ? res.data.data.products.filter(
              (product) => product.image !== "No image"
            )
          : [];
        setProductList(filteredProducts);
        // const filteredProducts = res.data?.data?.products?.filter(
        //   (product) => product.image !== "No image"
        // );
        // setProductList(filteredProducts);
        setShowList(true);
        onHide();
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  // console.log("productList:", productList);
  // Handle individual product selection
  const handleProductSelection = (product, isSelected) => {
    setSelectedProducts((prev) =>
      isSelected
        ? [...prev, product]
        : prev.filter((item) => item.productId !== product.productId)
    );
    setErrors((prevData) => ({ ...prevData, products: null }));
  };

  // Handle "Select All" checkbox
  const handleSelectAll = (isChecked) => {
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedProducts(productList);
    } else {
      setSelectedProducts([]);
    }
  };
  console.log("selectedAll:", selectedProducts);
  // Update "Select All" state when individual selections change
  // useEffect(() => {
  //   if (selectedProducts?.length === productList?.length) {
  //     setSelectAll(true);
  //   } else {
  //     setSelectAll(false);
  //   }
  // }, [selectedProducts, productList]);
  useEffect(() => {
    if ((selectedProducts?.length || 0) === (productList?.length || 0)) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedProducts, productList]);

  const handleAddProduct = () => {
    if (selectedProducts?.length === 0) {
      setErrors({
        products: "Please select at least one product to add to stock.",
      });
    } else {
      setAddModal(true);
    }
  };

  return (
    <>
      {loader}
      <div className="add-web-product">
        <div className="dashboard_title">
          <h3>
            <Link to={"/product-management/scrape"}>
              <IoMdArrowRoundBack size={24} />
            </Link>
            Web Scraped Products
          </h3>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Enter scrape Url..."}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
            <CustomButton
              onClick={() => {
                if (search) {
                  scrapeProductListHandler();
                } else {
                  setErrors({ search: "Please search the Url." });
                }
              }}
            >
              Search
            </CustomButton>
            {showList && (
              <>
                <CustomButton
                  ref={submitButtonRef}
                  className="button"
                  onClick={handleAddProduct}
                >
                  Add Product
                </CustomButton>
              </>
            )}
          </div>
          {errors && <div className="text-danger">{errors.products}</div>}
          {errors && <div className="text-danger">{errors.search}</div>}
        </div>

        {productList?.length > 0 && (
          <div className="select-all-wrapper">
            <label>
              <input
                type="checkbox"
                checked={selectAll}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              Select All
            </label>
          </div>
        )}

        <div className="product-grid">
          {productList?.length > 0 ? (
            <>
              {productList.map((product) =>
                product.image !== "No image" ? (
                  <div key={product.productId} className="product-card">
                    <div className="product_image">
                      <img src={product.image} alt={product.title} />
                    </div>
                    <h4>{product.brand}</h4>
                    <h5>{product.title}</h5>
                    <div className="feedback">
                      <p>
                        <FaStar />
                        <b> {product.averageRating}</b> Rating
                      </p>
                      <p>{product.totalReviews} Reviews</p>
                    </div>
                    <div className="footer_content">
                      <b className="discounted-price">₹{product.price}</b>
                      <label className="add_button">
                        <input
                          type="checkbox"
                          checked={selectedProducts.some(
                            (item) => item.productId === product.productId
                          )}
                          onChange={(e) =>
                            handleProductSelection(product, e.target.checked)
                          }
                        />
                        Add to Stock
                      </label>
                    </div>
                  </div>
                ) : null
              )}
            </>
          ) : (
            <Placeholder
              image={ProductPlaceholderImg}
              title="No Products Found"
            />
          )}
        </div>
      </div>
      <AddModel
        setAddModal={setAddModal}
        addModal={addModal}
        setErrors={setErrors}
        debouncedValue={search}
        selectedProducts={selectedProducts}
        errors={errors}
      />
    </>
  );
};

export default AddWebProduct;
